export default function (_text, length) {
  let text = _text;
  if (text && text.length > length) {
    text = text.substr(0, length);
    text += '...';
  }
  return text;
}



// WEBPACK FOOTER //
// ./app/src/shared/truncateFilter.js